import { Provider } from './providers/provider';
import { TrackingEvent, TrackingProviders } from '../types';

export class TrackingService {
  private _eventsQueue: TrackingEvent[] = [];
  private _providers: TrackingProviders = {};

  public constructor() {
    if (window.eventsQueue) {
      this._eventsQueue = JSON.parse(JSON.stringify(window.eventsQueue));
      window.eventsQueue = this;

      return;
    }

    window.eventsQueue = this;
  }

  public push(event: TrackingEvent) {
    const providerNames = Object.keys(event);

    providerNames.forEach((providerName: string) => {
      if (!this.providers[providerName]) {
        console.warn(
          `Cannot find provider '${providerName}', use the 'registerProvider()' method to register a new provider`
        );

        return;
      }

      this.providers[providerName].push(event[providerName]);

      delete event[providerName];
    });

    if (Object.keys(event).length > 0) {
      this._eventsQueue.push(event);
    }
  }

  public registerProvider(providerName: string, provider: Provider) {
    if (this.providers[providerName]) {
      throw new Error(`Provider '${providerName}' already exists`);
    }

    this.providers[providerName] = provider;

    this._pushQueuedEvents(providerName);
  }

  public unregisterProvider(providerName: string) {
    if (!this.providers[providerName]) {
      console.warn(`Cannot find provider '${providerName}'`);

      return;
    }

    delete this.providers[providerName];
  }

  public get providers(): TrackingProviders {
    return this._providers;
  }

  private _pushQueuedEvents(providerName: string) {
    for (let i = this._eventsQueue.length - 1; i >= 0; i--) {
      const event = this._eventsQueue[i];

      if (event[providerName]) {
        this.providers[providerName].push(event[providerName]);

        delete event[providerName];
      }

      if (Object.keys(event).length === 0) {
        this._eventsQueue.splice(i, 1);
      }
    }
  }
}
